import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useState } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  useDeleteProductsMutation,
  useGetProductsQuery,
  useUpdateProductsMutation,
} from "slices/eCommerce/shopProducts";
import { useGetShopCategoriesQuery } from "slices/eCommerce/shopCatSlice";
import { useSelector } from "react-redux";
import { hasActionAccess } from "utility";
import Swal from "sweetalert2";

function ShopProducts() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("");
  const [productType,setProductType]=useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [del] = useDeleteProductsMutation();
  const auth = useSelector((state) => state.auth.auth?.user);
  const [update] = useUpdateProductsMutation();

  const { data, refetch } = useGetProductsQuery({
    page,
    limit,
    search,
    category,
    productType
  });

  const { data: mainCat } = useGetShopCategoriesQuery({});

  const col = [
    { display: "Name", key: "name", type: "display" },
    { display: "Description", key: "description", type: "display" },
    {
      display: "Thumbnail",
      key: "thumbnail",
      type: "image",
      style: { width: "100px", height: "100px", borderRadius: "20%" },
    },
    {
      display: "Status",
      key: "isAvailable",
      type: "display",
      render: (row) => (
        <input
          type="checkbox"
          checked={row.isAvailable === true}
          onChange={() => handleStatusToggle(row._id, !row.isAvailable)}
          style={{
            width: "18px",
            height: "18px",
            accentColor: row.isAvailable ? "green" : "red",
            cursor: "pointer",
          }}
        />
      ),
    },
  ];

  const canEdit = hasActionAccess(auth, "E-Commerce", "Products", "edit");
  const canDelete = hasActionAccess(auth, "E-Commerce", "Products", "delete");
  if (canEdit || canDelete) {
    col.push({
      display: "Actions",
      key: "edit",
      type: "action",
      render: (row, onEdit, handleDelete) => (
        <>
          {canEdit && <Button onClick={() => onEdit(row)}>Edit</Button>}
          {canDelete && (
            <Button onClick={() => handleDelete(row._id)}>Delete</Button>
          )}
        </>
      ),
    });
  }

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };

  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1; // MUI is 0-based, API is 1-based
    setPage(apiPage);
    setLimit(newLimit);
  };

  const onEdit = (row) => {
    navigate(`/e-commerce/products/update-product/${row._id}`, {
      state: { refresh: true },
    });
  };

  const handleAdd = () => {
    navigate("/e-commerce/products/add-product");
  };
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this product?")) {
      await del(id).unwrap();
      refetch();
    }
  };
  const onTabClick = (index, item) => {
    if (index === 0) {
      setCategory("");
    } else {
      setCategory(item._id);
    }
  };

  const handleStatusToggle = async (id, newStatus) => {
    try {
      let response = await update({
        id,
        body: { isAvailable: newStatus },
      }).unwrap();

      console.log("response", response);
      if (response?.success === true) {
        refetch();
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err?.message || "Error updating status",
      });
    }
  };

  const canAdd = hasActionAccess(auth, "E-Commerce", "Products", "add");

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {canAdd && (
        <Button onClick={handleAdd} style={{ background: "#fff" }}>
          Add Product
        </Button>
      )}

      <Tables
        tabs={mainCat?.data}
        title={"Products"}
        handleSearch={handleSearchChange}
        totalPages={data?.data?.pagination?.totalPages}
        data={data?.data?.data}
        columns={col}
        filterData={{'data':[{_id:'user',cityName:'user'},{_id:'beautician',
          cityName:'beautician'}],'for':'Product Type', labelKey: "cityName", onChange: (cityId) => {
      setProductType(cityId);      
      refetch();      
    }}}
        changePage={changePage}
        onEdit={onEdit}
        handleDelete={handleDelete}
        onTabClick={onTabClick}
        currentPage={page} // ✅ pass to control current pagination
        rowsPerPage={limit}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default ShopProducts;
